import React, { useState, useRef, useEffect } from "react";

//Importar helpers y constantes. 
import { verifyCondition_unselected } from "../../../const/conditionalConstants/unselectedChatRender.js";
import { verifyCondition_session } from "../../../const/conditionalConstants/sessionRender.js";
import { verifyCondition_sessionHeight } from "../../../const/conditionalConstants/sessionHeightByStatus.js";
import useUpdateSelectedChat from "../../../hooks/useUpdateSelectedChat .js";
import useScrollToBottom from "../../../hooks/useScrollToBottom.js";
import SocketEventHandlerComponent from "../../SocketEventHandler.jsx";
import useHeigthCalculator from "../../../hooks/useHeightCalculator.js";

//Importar componenetes a renderizarse.
import PreviewFileSelected from "./local_components/Components/PreviewFileSelected.jsx";
import UnselectedChat from "./local_components/Components/UnselectedChat.jsx";
import Session from "./local_components/Sessions/Session.jsx";
import WriteMessage from "./local_components/Components/WriteMessage.jsx";
import QuickMessages from "./local_components/Components/QuickMessages.jsx";
import ModalMessageFileSize from "../../common/Modal/ModalMessageFileSize.jsx";
import { verifyCondition_quickMessages } from "../../../const/conditionalConstants/quickMessagesRender.js";
import LoadingChatsPreview from "../../common/Loading/LoadingChatsPreview.jsx";

// BodyChat: Componente que renderiza el contenido del cuerpo del chat (sesiones del chat, 
// botones para subir archivos multimedia e iconos, campo para escribir un mensaje).

const BodyChat = ({ chatData, sessionsChatSelected, socketConnected, loadingChat, setLoadingChat }) => {
    const containerRef = useRef(null); //Referencia para el contenedor de los mensajes y para calcular el alto del contenedor de las sesiones..
    const [sessions, setSessions] = useState([]);  //Estados para actualizar las sesiones del chat seleccionado.
    const [sessionSelected, setSessionSelected] = useState({}); //Estado para actualizar los datos de la sesión seleccionada.
    const [filesSelected, setFilesSelected] = useState([]); //Array con los archivos multimedia seleccioandos para enviar.
    const [typeFile, setTypeFile] = useState(""); //Estado para definir el tipo de archivo multimedia seleccionado.
    const [sessionExpanded, setSessionExpanded] = useState(false); //Estado para actualizar si la sesion dentro del contenedor fue expandida, para mostrar los mensajes rapidos.
    const [openMessageFileSize, setOpenMessageFileSize] = useState(false); //Estado para abrir o cerrar el mensaje de que el archivo multimedia subido supera el máximo permitido.
    const [messagesArray, setMessagesArray] = useState([]); //Array para guardar la lista de mensajes con el nombre del archivo al que le pertenece.
    const bodyChatRef = useRef(null); //Referencia para el contenedor del chat, para calcular la altura de la sesión.

    // Verificar condiciones para renderizar componentes.
    let UNSELECTED_CHAT_CONDITION = verifyCondition_unselected(socketConnected, sessionsChatSelected);
    let SESSION_CONDITION = verifyCondition_session(filesSelected, socketConnected, sessionsChatSelected, loadingChat);

    /* let SESSION_HEIGHT_BY_STATUS_CONDITION = verifyCondition_sessionHeight(sessionSelected); //Se usa solo en el caso de que no 
        // se quiera que se puedan enviar mensajes luego de ser finalizada la sesión.  */
        
    let QUICK_MESSAGES_CONDITION = verifyCondition_quickMessages(socketConnected, filesSelected); //Si no existen archivos multimedias por subir.

    const handleClosePreview = () => { //Funcion para manejar el cierre de la ventana de vista previa.
        setFilesSelected([]); //Vaciar la lista de archivos multimedia seleccionados.
        setMessagesArray([]); //Vaciar la lista de mensajes asociados a los archivos.
        setTypeFile(""); //Setear el tipo de archivo seleccionado a vacio.
    };

    //Función de callback para actualizar la sesión seleccionada desde el chat abierto.
    const onSelectedSession = (session) => setSessionSelected(session);

    //Se ejecuta cada vez que cambia el chat seleccionado desde el Inbox.
    useUpdateSelectedChat(sessionsChatSelected, chatData, setSessions, setSessionSelected, handleClosePreview);

    //Se ejecuta para scrollear al final del contenedor de las sesiones.
    useScrollToBottom(containerRef, sessionSelected, loadingChat, setLoadingChat);

    //Se ejecuta para calcular el alto del contenedor de la sesion para adaptarlo al alto.
    let containerRefHeight = useHeigthCalculator(bodyChatRef);

    useEffect(() => { if (chatData.IdChat) {setLoadingChat(true);} }, [chatData]); //Mostrar el cargando chat.
    
    return (
        <>
            {/* Renderiza el componente SocketEventHandlerComponent */}
            <SocketEventHandlerComponent sessionsChatSelected={sessionsChatSelected} setSessions={setSessions}
                chatData={chatData} />

            {/*---Mensaje cuando el tamaño del archivo multimedia es mayor al permitido-----*/}
            <ModalMessageFileSize openMessageFileSize={openMessageFileSize} setOpenMessageFileSize={setOpenMessageFileSize} />

            <div className="container-chat__content" ref={bodyChatRef} >

                {/*---------Contenido para cuándo no se muestra ningún chat------------*/}
                {UNSELECTED_CHAT_CONDITION && <UnselectedChat />}

                {loadingChat && <LoadingChatsPreview chatData={chatData}/>}
                
                {/*---------Contenedor de cada sesión------------*/}
                {SESSION_CONDITION &&
                    <div ref={containerRef}
                        className={`container-chat__content--sessions`} >
                        {sessions.map((session) => (
                            <Session sessions={sessions} sessionSelected={sessionSelected}
                                setFilesSelected={setFilesSelected} filesSelected={filesSelected} key={session.IdSession}
                                session={session} chatData={chatData} onSelectedSession={onSelectedSession}
                                setTypeFile={setTypeFile} containerRefHeight={containerRefHeight}
                                setSessionExpanded={setSessionExpanded} setOpenMessageFileSize={setOpenMessageFileSize} />))
                        }
                    </div>}


                <div className="container-chat__write-with-quick-messages">
                    {/*----------------------Mensajes rápidos------------------------*/}
                    {/* QUICK_MESSAGES_CONDITION && sessions.map((session) => (<QuickMessages key={session.IdSession} sessionSelected={sessionSelected}
                        expanded={sessionExpanded} session={session} />)) */}

                    {/*------------Contenedor del campo para escribir un nuevo mensaje------------*/}
                    <WriteMessage sessionSelected={sessionSelected} socketConnected={socketConnected} loadingChat={loadingChat}
                        filesSelected={filesSelected} sessionsChatSelected={sessionsChatSelected}
                        setFilesSelected={setFilesSelected} setTypeFile={setTypeFile} setOpenMessageFileSize={setOpenMessageFileSize} />
                </div>

                {/*---Contenedor vista previa de un archivo multimedia seleccionado-----*/}
                <PreviewFileSelected typeFile={typeFile} filesSelected={filesSelected}
                    setFilesSelected={setFilesSelected} sessionSelected={sessionSelected} setOpenMessageFileSize={setOpenMessageFileSize}
                    messagesArray={messagesArray} setMessagesArray={setMessagesArray} handleClosePreview={handleClosePreview} />

            </div>


        </>
    );
};

export default BodyChat;